import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import {
  addMonths,
  endOfMonth,
  endOfWeek,
  format,
  startOfMonth,
  startOfWeek,
  subMonths,
  isSameDay,
  isSameMonth,
} from 'date-fns';
import { es } from 'date-fns/locale';
import { ChevronLeft } from '../../icons/chevron-left/chevron-left';
import { ChevronRight } from '../../icons/chevron-right/chevron-right';

@Component({
  selector: 'app-appointment-calendar',
  imports: [CommonModule, ChevronLeft, ChevronRight],
  templateUrl: './appointment-calendar.html',
  styleUrl: './appointment-calendar.css',
})
export class AppointmentCalendar {
  today = new Date();
  currentMonth = signal(new Date());
  selectedDate = signal<Date | null>(null);
  weeks = signal<Date[][]>([]);
  locale = es;
  @Input() value: Date | null = null;

  @Output() dateSelected = new EventEmitter<Date>();

  constructor() {
    this.selectedDate.set(this.today);
    this.generateCalendar();
    this.dateSelected.emit(this.today);
  }

  generateCalendar() {
    const start = startOfWeek(startOfMonth(this.currentMonth()), {
      weekStartsOn: 0,
    });
    const end = endOfWeek(endOfMonth(this.currentMonth()), { weekStartsOn: 0 });

    const cursor = new Date(start);
    const weeks: Date[][] = [];
    let currentWeek: Date[] = [];

    while (cursor <= end) {
      currentWeek.push(new Date(cursor));
      if (currentWeek.length === 7) {
        weeks.push(currentWeek);
        currentWeek = [];
      }
      cursor.setDate(cursor.getDate() + 1);
    }

    this.weeks.set(weeks);
  }

  previousMonth() {
    this.currentMonth.set(subMonths(this.currentMonth(), 1));
    this.generateCalendar();
  }

  nextMonth() {
    this.currentMonth.set(addMonths(this.currentMonth(), 1));
    this.generateCalendar();
  }

  selectDate(date: Date) {
    this.selectedDate.set(date);
    this.dateSelected.emit(date);
  }

  isSameDay = isSameDay;
  isSameMonth = isSameMonth;
  format = format;
}
